
import React, { useContext } from 'react'
import InputRadioSelect from '../../Custom/CustomInput/InputRadioSelect'
import SearchFieldsContext from '../context/context'
export function TenantInfoFilter() {
  const { searchFields, setSearchFields } = useContext(SearchFieldsContext)
  function handleChange(params) {
    const newSearchFields = searchFields
    newSearchFields.tenantInfoFields[params.index] = { ...params.value, ...params.model }
    let isRadioButtonSelected = searchFields.tenantInfoFields.find(fields => fields.type === "radio").groupList.findIndex(r => r.selected)
    if (params.value.type === "checkbox" && isRadioButtonSelected === -1) {
      newSearchFields.tenantInfoFields[1].groupList.forEach(f=> {
        if(f.key === "only") {
          f.selected = true
        }
      })
    }
    setSearchFields({ ...newSearchFields })
  }

  return (
    <div>
      {searchFields ?
        searchFields.tenantInfoFields.map((value, index) => {
          function onchangeEvent(model) {
            handleChange({ model, index, value })
          }

          return (<>
            <div className="form-row" key={`TenantFilter${index}`}>
              {value.type === 'checkbox' ?
                <InputRadioSelect groupList={value.groupList} type={value.type} onChange={onchangeEvent} /> : <InputRadioSelect groupList={value.groupList} type={value.type} groupName={value.groupName} onChange={onchangeEvent} />}
            </div>
            {searchFields.tenantInfoFields.length === index + 1 ? '' : <hr />}
          </>
          )
        }) : null}
    </div>
  )
}
export default TenantInfoFilter
